var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3 720.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:3px;}.cls-2{stroke-dasharray:12.01 12.01;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.5,
    x2: 1.5,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1.5,
    y1: 18.01,
    x2: 1.5,
    y2: 708.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.5,
    y1: 714.62,
    x2: 1.5,
    y2: 720.62
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparator);
export default __webpack_public_path__ + "static/media/separator.b9ce55ab5dbb5d05cb3c7f1632ff632c.svg";
export { ForwardRef as ReactComponent };